window.tailwindConfig = {
  theme: {
    extend: {
      colors: {},
      fontFamily: {
        roboto: ['Roboto', 'sans-serif'],
      },
      maxWidth: {
        container: '1200px',
      },
      screens: {
        xxl: '1200px',
      },
    },
  },
};
